"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBellRingingFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.bell-ringing_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "bell-ringing_filled_svg__transparent_box" },
            React.createElement("path", { className: "bell-ringing_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "bell-ringing_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "bell-ringing_filled_svg__FILLED" },
            React.createElement("path", { className: "bell-ringing_filled_svg__cls-1", d: "M15.99 22h-.02.02z" }),
            React.createElement("path", { d: "M16 22h-2.81a3.66 3.66 0 00.18.46A2.78 2.78 0 0016 24a2.77 2.77 0 002.61-1.54 3.71 3.71 0 00.19-.46H16zM22 17.63l-.74-.4a2.15 2.15 0 01-.8-1.93v-.5c0-3-1.67-4.8-4.46-4.8s-4.46 1.84-4.46 4.8v.5a2.23 2.23 0 01-.8 1.93l-.74.4V20h12zM5.87 7.9L4.44 6.48a14.94 14.94 0 000 19.1l1.43-1.42a12.92 12.92 0 010-16.26z" }),
            React.createElement("path", { d: "M6.4 10.63a10.92 10.92 0 000 10.77L8 20.11a9 9 0 010-8.19zM27.51 6.48L26.09 7.9a12.93 12.93 0 010 16.26l1.43 1.42a14.94 14.94 0 000-19.1z" }),
            React.createElement("path", { d: "M25.56 10.63L24 11.92a9 9 0 010 8.19l1.58 1.29a11 11 0 000-10.77z" }))));
}
exports.default = SvgBellRingingFilled;
//# sourceMappingURL=BellRingingFilled.js.map